import { render, staticRenderFns } from "./table-header.vue?vue&type=template&id=4097bbe1"
import script from "./table-header.ts?vue&type=script&lang=ts&external"
export * from "./table-header.ts?vue&type=script&lang=ts&external"
import style0 from "./table-header.scss?vue&type=style&index=0&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/src/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4097bbe1')) {
      api.createRecord('4097bbe1', component.options)
    } else {
      api.reload('4097bbe1', component.options)
    }
    module.hot.accept("./table-header.vue?vue&type=template&id=4097bbe1", function () {
      api.rerender('4097bbe1', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/ag-grid-table/header-types/table-header.vue"
export default component.exports